<template>
    <div class="footer">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="content-sm">
                        <div class="text-center">
                            <SectionHeader
                                title="Become a Part of the CrossProm Community"
                                desc="We designed CrossProm to be super easy to use. But if you need a little extra help or wish there were more features, our team is ready to answer all your questions."
                                :text-white="true"/>
                            <Button 
                                id="join-community-footer-button" 
                                type="landing-green" 
                                @click.native="checkAuthState"
                            >
                                Join Community
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <Button id="phone-calendly-icon" @click.native="calendly" class="calendly">
                <Icon icon="landing-calendly"/>
            </Button>
        </div>
    </div>
</template>

<script>
import SectionHeader from './SectionHeader'
import Button from '@/components/Theme/Button'
import useAuthCheck from './useAuthCheck'
import CheckoutButton from '@/components/CheckoutButton'
import Icon from '@/components/Theme/Icon'
import { computed, ref } from '@vue/composition-api'
import { useStore, useUserId } from '../../core/hooks'
import {getData} from '../../firebaseCRUD'
import moment from 'moment'
export default {
    name: 'Footer',
    components: {
        Button,
        SectionHeader,
        Icon,
        CheckoutButton
    },
    props: {
        externalTitle: String,
        externalDescription: String
    },
    setup(props, context) {
        const { checkAuthState } = useAuthCheck('Landing Join Community Bottom')
        const { state, store} = useStore()

        const isLoggedIn = computed(() => state.value.user && state.value.idToken)
        const user = computed(() => state.value.user)
        const membershipStatus = computed(() => store.getters.membershipStatus)
        const isInTrial = computed(() => store.getters.hasTrial)
        const trialExpired = computed(() => store.getters.trialExpired)
        const externalButtonText = computed(() => {
            if(!isLoggedIn.value) {
                return 'Try for free'
            }
            if(isInTrial.value || trialExpired.value) {
                return 'Upgrade Now'
            }
        })

        const calendly = () => {
            context.root.$sendMixpanelEvent('Calendly Modal Opened', {
                'Opened From': 'Landing Phone Icon'
            })
            context.root.$ga.event('Calendly', 'Modal Opened', 'OpenedFrom', 'Landing Phone Icon')
            Calendly.initPopupWidget({
                url: 'https://calendly.com/teamcrossprom/crossprom-for-your-kickstarter-campaign'
            })
        }
        return {
            checkAuthState,
            calendly,
            user,
            membershipStatus
        }
    }
}
</script>

<style scoped lang="scss">
$mob_buttonSize: 16px;
$mob_imgsize: 65px;
.footer {
    padding-top: 113px;
    padding-bottom: 88px;
    background: #727CF5;
    
    
    .content-sm {
        div {
            max-width: 688px;
            margin: 0 auto;
            button {
                margin-top: 24px;
                &#join-community-footer-button {
                    font-size: 18px !important;
                    padding: 24px 67px 24px 67px !important;
                }

            }
        }
        &__external-button {
            width: 200px;
            height: 48px;
        }
    }
    button.calendly {
        margin-right: 80px
    }
}
@media (max-width: 767px) {
    div.footer {
        padding-top: 48px !important;
        padding-bottom: 96px;

        button {
            font-size: $mob_buttonSize;
        }
        button.calendly {
            margin-right: 16px;
            margin-top: 24px;
            img {
                width: $mob_imgsize
            }
        }
    }
}
</style>